const routes = [
    {
        path: '/emissor/exclusao_dados',
        component: () => import('../views/ExcluirDados')
    }
]

export default routes
